import styled, { css } from 'styled-components';
import { largeLayout, getFullHeightSectionHeight } from '@styles/layout';

export const FullHeightSection = styled.section`
  height: ${(props) => getFullHeightSectionHeight(props.theme.windowHeight, props.theme.windowWidth)}px;
  background: white;
  overflow: hidden;
`;

type SectionContentProps = {
  fullHeight?: boolean;
};

export const SectionContent = styled.main`
  max-width: ${largeLayout.getSize()}px;
  margin: 0 auto;
  position: relative;
  ${(props: SectionContentProps) => props.fullHeight ? css`height: 100%;` : ''}
`;


// WEBPACK FOOTER //
// src/app/src/components/Sections/Sections.s.ts